import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getLast3Months } from "../../utils/getLast3Months";
import { ApiHook } from "../../hooks/apiHook";
import { ProgressBar } from "react-bootstrap";
import { getLast2Years } from "../../utils/getLast2years";
import Skeleton from "react-loading-skeleton";
import IncentivesSkeleton from "./IncentivesSkeleton";
import { months } from "../../utils/months";
import { useParams } from "react-router";

const GlobalRallyView = () => {
  const params = useParams();

  const [selectedMonth, setSelectedMonth] = useState(getLast2Years()?.[0].year);
  const [userId, setUserId] = useState(params.id);
  const { t } = useTranslation();
  const [state, setState] = useState([]);
  const data = ApiHook.CallGlobalRally(selectedMonth,userId);

  const handleMonthChange = (month) => setSelectedMonth(month);



  /**
   * Helper to render a progress bar with required values
   */
  const renderProgressBar = (required, current) => {
    if (required == null || isNaN(required)) return "N/A";

    const currentValue = parseFloat(current) || 0;
    const requiredValue = parseFloat(required) || 0;

    return (
      <>
        <ProgressBar
          variant="success"
          now={currentValue}
          max={requiredValue}
          label={`${currentValue} / ${requiredValue}`}
        />
        <span className="required-text">
          {requiredValue} {t("required") || "Required"}
        </span>
      </>
    );
  };

  const renderIcons = (renderCondition) => {
    if (renderCondition == null) return null;

    return renderCondition ? (
      <i
        className="fa fa-check-circle"
        style={{
          color: "green",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    ) : (
      <i
        className="fa fa-times-circle"
        style={{
          color: "red",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    );
  };

  const countIndicator = (required, current) => {
    if (required == null || current == null) return "N/A";

    return (
      <>
        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "flex-start",
          }}
        >
          {/* Row of boxes */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {[...Array(required)].map((_, idx) => (
              <div
                key={idx}
                style={{
                  height: "20px",
                  width: "20px",
                  border: "1px solid green",
                  backgroundColor: current > idx ? "green" : "transparent",
                }}
              />
            ))}
          </div>

          <span
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              alignContent: "center",
            }}
          >
            {required}
          </span>
        </div>
      </>
    );
  };

  const isUserQualified = () => {
    if (!data?.data) return false;

    const { months, summary, config } = data.data;

    // Check all qualification criteria
    const isActiveEveryMonth = months?.every((obj) => obj.activeStatus);
    const hasEnoughTotalPv = summary?.totalPv >= config?.total_cc;
    const hasEnoughNewPv = summary?.totalNewCC >= config?.new_cc;
    const hasEnoughSupervisors =
      summary?.superVisors >= config?.supervisor_lines;

    // User is qualified only if ALL conditions are met
    return (
      isActiveEveryMonth &&
      hasEnoughTotalPv &&
      hasEnoughNewPv &&
      hasEnoughSupervisors
    );
  };
  if (data.isLoading) {
    return <IncentivesSkeleton />;
  }
  const qualified = isUserQualified();

  return (
    <div className="ewallet_top_btn_sec">
      <div className="row justify-content-between">
        <div className="col-md-4"></div>
        <div className="col-md-4 text-end "></div>
      </div>
      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="table-responsive min-hieght-table">
            <h6 className="table-heading-incentives">{t("globalRally")}</h6>
            <div className="row incentives-subheading justify-content-between">
               <span>{t("Name")} : {data?.data?.fullName}</span>
                <span>{t("User Name")} : {data?.data?.username}</span>
            </div>
            <div className="table-container">
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <h5>{t("Total KC Year-To-Date")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("You have")} :{" "}
                        {parseFloat(
                          data?.data?.currentYearData?.totalKC ?? 0
                        ).toFixed(3)}{" "}
                        {renderIcons(
                          Number(data?.data?.currentYearData?.totalKC) >=
                            Number(data?.data?.Configuration?.min_total_cc)
                        )}
                      </p>
                    </td>
                    <td colSpan={6}>
                      {renderProgressBar(
                        data?.data?.rallyLevel?.nextLevel?.cc,
                        data?.data?.currentYearData?.totalKC
                      )}
                    </td>
                  </tr>
                  {data?.data?.rallyLevel?.new_cc_status && (
                    <tr>
                      <td>
                        <h5>{t("newPv")}</h5>
                        <p
                          style={{
                            fontSize: "14px",
                            color: "#333",
                            marginTop: "10px",
                          }}
                        >
                          {t("You have")} :{" "}
                          {parseFloat(
                            data?.data?.currentYearData?.new_kc ?? 0
                          ).toFixed(3)}{" "}
                          {renderIcons(
                            Number(data?.data?.currentYearData?.new_kc) >=
                              Number(data?.data?.Configuration?.min_new_cc)
                          )}
                        </p>
                      </td>
                      <td colSpan={6}>
                        {renderProgressBar(
                          data?.data?.Configuration?.min_new_cc,
                          data?.data?.currentYearData?.new_kc
                        )}
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td>
                      <h5>{t("Level Achieved")}</h5>
                    </td>
                    <td colSpan={6}>
                      {data?.data?.rallyLevel?.qualificationStatus}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("Next Level")}</h5>
                    </td>
                    <td colSpan={6}>
                      {data?.data?.rallyLevel?.nextLevel?.name}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <h5>
                         {t("Total KC Needed for", { level: data?.data?.rallyLevel?.nextLevel?.name })}
                        
                   
                      </h5>
                    </td>
                    <td> {data?.data?.rallyLevel?.remainingCC}</td>
                  </tr>
                  <tr>
                    <td>
                      Total KC estimate for the current month - will go down if
                      downline Leaders become 4KC Active
                    </td>
                    <td> {data?.data?.currentYearData?.currentMonthTotalKC}</td>
                  </tr>
                </tbody>
              </table>
              
 <div className="row" style={{ padding: "20px" }}>

    {data?.data?.rallyLevel?.details?.incentives?.length > 0 && (
    <>
      <div className="col-md-12">
        <h4>Current Level Rewards</h4>
      </div>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        {data?.data?.rallyLevel?.details?.incentives.map((incentive, index) => (
          <li key={index}>{incentive?.incentiveData?.name}</li>
        ))}
      </ul>
    </>
  )}
  {data?.data?.rallyLevel?.nextLevel?.incentives?.length > 0 && (
    <>
      <div className="col-md-12">
        <h4>{t("Next Level Rewards")}</h4>
      </div>
      <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
        {data?.data?.rallyLevel?.nextLevel?.incentives.map((incentive, index) => (
          <li key={index}>{incentive?.incentiveData?.name}</li>
        ))}
      </ul>
    </>
  )}

</div>
              {/* ===== Month Tabs ===== */}
              <div className="month-tabs">
                {getLast2Years().map((year) => (
                  <button
                    key={year.value}
                    className={`month-tab ${
                      selectedMonth === year.value ? "active" : ""
                    }`}
                    onClick={() => handleMonthChange(year.value)}
                  >
                    {year.value}
                  </button>
                ))}
              </div>
            </div>
        
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalRallyView;
